import styled from 'styled-components';

export const FileDownload = styled.div`
  flex-grow: 1;
  text-align: right;
  padding: 0 0.2em;
`;
